import React from "react";
import "../../Assets/Styles/pages/landing.scss";
import { Features } from "../../Config/features";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import LazyLoad from "react-lazyload";

const WaterMarkFeature = ({ view }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const handleFeatures = () => {
    history.push("/features");
  };

  return (
    <>
      <div className="w-100 d-flex flex-column align-items-center justify-content-center">
        <Row onLoad={() => {}} className="px-md-5 features w_90 ">
          {Features.filter((feature) => feature.landing === view || !view)?.map(
            (feature, i) => (
              <Row
                key={i}
                className="m-0 my-5 my-lg-0 d-flex flex-lg-row flex-column-reverse justify-content-between align-items-center feature p-lg-2 p-0"
              >
                <Row className="p-0 w-50 w_45_lg w-xs-100 mt-5 p-lg-2 pt-lg-3">
                  <Row className="featureTitleColor text-uppercase text_18 mb-2 productSansBold m-0">
                    {t(feature.title)}
                  </Row>
                  <Col className="text_40 line_height_2_9 pe-0 productSans mb-3 mb-lg-0">
                    {t(feature.sub_title1)}
                    <span className="landing_banner_Heading productSansBold">
                      {t(feature.sub_titlespan)}
                    </span>
                    {t(feature.sub_title2)}
                  </Col>
                  <p className="productSansLight mt-4 mb-1 text_18">
                    {t(feature.description) +
                      (!view ? t(feature.extended) : "...")}
                  </p>
                  {view === true ? (
                    <Row
                      onClick={handleFeatures}
                      className="m-0 viewText productSans text_18 pointer maxWidthContent"
                    >
                      {t("ViewAll")}
                    </Row>
                  ) : null}
                </Row>
                <Row
                  className={`${feature.bg} m-0 d-flex justify-content-end p-0 w_40 w-xs-100  mt_138 featureImg `}
                >
                  {/* <LottiePlayer src={feature.image} /> */}
                  <LazyLoad once>
                    <img alt="feature" className="w-100" src={feature.image} />
                  </LazyLoad>
                </Row>
              </Row>
            )
          )}
        </Row>
      </div>
    </>
  );
};

export default WaterMarkFeature;
